// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  min-height: 100vh;
  background-color: var(--color-background-primary);
  position: relative;
  display: flex;
  flex-direction: column;
}

.blur-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  overflow: hidden;
  z-index: 1;
}

@media (min-width: 700px) {
  .blur-top {
    display: none;
  }
  
  .app-content {
    padding-top: 0;
    min-height: 100vh;
  }
}

.blur-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.app-content {
  flex: 1 1;
  position: relative;
  z-index: 2;
  min-height: calc(100vh - 180px);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/AppLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC","sourcesContent":[".app-layout {\n  min-height: 100vh;\n  background-color: var(--color-background-primary);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.blur-top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 200px;\n  overflow: hidden;\n  z-index: 1;\n}\n\n@media (min-width: 700px) {\n  .blur-top {\n    display: none;\n  }\n  \n  .app-content {\n    padding-top: 0;\n    min-height: 100vh;\n  }\n}\n\n.blur-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n}\n\n.app-content {\n  flex: 1;\n  position: relative;\n  z-index: 2;\n  min-height: calc(100vh - 180px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
